import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import config from 'config/config';
import { Auth } from 'aws-amplify';

class ProtectedRoute extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: '',
            isClientAuthenticated: sessionStorage.getItem(config.CLIENT_TOKEN),
            isMounted: false
        };
    }

    componentDidMount() {
        Auth.currentSession()
            .then((response) => {
                this.setState({ isAuthenticated: response.accessToken.jwtToken });
                localStorage.setItem(config.TOKEN, response.accessToken.jwtToken);
            }).catch(() => {
                this.setState({ isAuthenticated: null });
                localStorage.removeItem(config.TOKEN);
            }).finally(() => {
                this.setState({ isMounted: true });
            });
    }

    render() {
        if (this.state.isMounted) {
            if ((this.props.restricted && this.state.isAuthenticated) || (!this.props.restricted)) {
                return <Route {...this.props} />;
            }
            if ((this.props.clientRestricted && this.state.isClientAuthenticated)) {
                return <Route {...this.props} />;
            }
            return <Redirect to={{ pathname: '/login' }} />;
        }
        /**
         * @todo return loading page
         */
        return null;
    }
}

export default ProtectedRoute;
